import axios from "axios";
const { natus_env } = require("../../config");

export default axios.create({
  // baseURL: "https://akillitasmaapiwin-test.azurewebsites.net/api/",
  // baseURL: "https://londonapi.natustech.com/api/",
  // baseURL: "https://localhost:44362/api/",
  baseURL:
    natus_env == "production"
      ? "https://akillitasmaapiwin.azurewebsites.net/api/"
      : "https://akillitasmaapiwin-test.azurewebsites.net/api/",
  // baseURL: "https://localhost:44362/api/",

  responseType: "json",
});
